import { SPLICE } from 'constants/general';
import { SORT_OPTION } from 'enums';

export const asArray = <T>(value: unknown): T[] =>
  Array.isArray(value) ? value : [];

export const hasSingleItem = <T>(list: readonly T[]): boolean =>
  list.length === 1;

export const hasItems = <T>(list: readonly T[]): boolean => list.length > 0;

export const hasAnyItems = <T>(
  ...lists: readonly (readonly T[])[]
): boolean => lists.some((list) => list.length > 0);

export const take = <T>(
  list: readonly T[],
  limit: number,
  offset = 0
): T[] => list.slice(offset, offset + limit);

export const insertAt = <T>(list: T[], index: number, item: T): void => {
  list.splice(index, SPLICE.INSERT, item);
};

export const removeAt = <T>(
  list: T[],
  index: number,
  deleteCount: number = SPLICE.DELETE
): T | undefined => {
  const [removed] = list.splice(index, deleteCount);
  return removed;
};

export const sortBy = <T>(
  list: readonly T[],
  getSortValue: (item: T) => number,
  direction: SORT_OPTION = SORT_OPTION.ASC
): T[] => {
  const directionFactor = direction === SORT_OPTION.ASC ? 1 : -1;
  return [...list].sort(
    (first, second) =>
      (getSortValue(first) - getSortValue(second)) * directionFactor
  );
};

export const getMaxBy = <T>(
  list: readonly T[],
  getSortValue: (item: T) => number
): T | null => {
  if (list.length === 0) {
    return null;
  }
  return list.reduce((best, item) =>
    getSortValue(item) > getSortValue(best) ? item : best
  );
};
